import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getStripeEnvironment } from "@/lib/stripe";

export function PaymentTestModeBanner() {
  if (getStripeEnvironment() !== "test") return null;

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "warning.light",
        color: "warning.contrastText",
        px: 2,
        py: 1,
        textAlign: "center",
        borderBottom: "1px solid",
        borderColor: "warning.main",
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 500 }}>
        Stripe is running in test mode. Use Stripe test cards (e.g. 4242 4242 4242 4242).
      </Typography>
    </Box>
  );
}
